import React from 'react';
import { XIcon } from 'lucide-react';
import { problems } from '../data/comparison';
import { Eyebrow } from './Eyebrow';
export function Problems() {
  return <section aria-labelledby="problems-heading" className="bg-wine-dark py-16 sm:py-24" data-id="element-284" data-mp="36xu90s8z6xk5">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-285" data-mp="322y6uza0yttb">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,24rem)_minmax(0,1fr)] lg:gap-20" data-id="element-286" data-mp="2y48th6ozlc9o">
          <div data-id="element-287" data-mp="2t4mi72spy63i">
            <Eyebrow tone="rose" data-id="element-288" data-mp="2t55r5u0e5k5e">Rzeczywistość nauczania jazzu</Eyebrow>
            <h2 id="problems-heading" className="mt-5 font-display text-4xl leading-[0.98] text-cream sm:text-5xl" data-id="element-289" data-mp="2o4qdt2g40cnf">
              Jeśli uczysz gitary jazzowej, <span className="text-amber" data-id="element-290" data-mp="2f4uzwpv663jp">znasz już tę listę.</span>
            </h2>
            <p className="mt-6 border-l-2 border-rose pl-5 font-serif text-xl italic leading-snug text-cream-soft" data-id="element-291" data-mp="heto4gbaaz0l">
              Jak długo jeszcze zamierzasz improwizować?
            </p>
          </div>
          <ul className="divide-y divide-wine/60" data-id="element-292" data-mp="34qv1wh3h0kid">
            {problems.map(problem => <li key={problem} className="flex items-start gap-4 py-5 first:pt-0 last:pb-0" data-id="element-293" data-mp="39py65zbmmmpa">
                <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-rose-deep" data-id="element-294" data-mp="39nlhl3bd5e39">
                  <XIcon className="h-3.5 w-3.5 text-rose" aria-hidden="true" data-id="element-295" data-mp="2zricbol7szc3" />
                </span>
                <span className="text-base leading-relaxed text-cream-soft" data-id="element-296" data-mp="3ngukqm8px3dc">{problem}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}